import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-060d8ed0")

_pushScopeId("data-v-060d8ed0")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#input-with-icon" }),
  /*#__PURE__*/_createTextVNode(" Input with icon ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Add an icon to indicate input type. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "demo-input-suffix mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "demo-input-label" }, "Using attributes", -1)
const _hoisted_7 = { class: "demo-input-suffix" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "demo-input-label" }, "Using slots", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "el-input__icon el-icon-date" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "el-input__icon el-icon-search" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_input, {
          placeholder: "Pick a date",
          "suffix-icon": "el-icon-date",
          modelValue: _ctx.input1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.input1 = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          placeholder: "Type something",
          "prefix-icon": "el-icon-search",
          modelValue: _ctx.input2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.input2 = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_input, {
          placeholder: "Pick a date",
          modelValue: _ctx.input3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.input3 = $event))
        }, {
          suffix: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          placeholder: "Type something",
          modelValue: _ctx.input4,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.input4 = $event))
        }, {
          prefix: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
})